import { Directive } from '@angular/core';

@Directive({
  selector: '[suiDialogHeader]',
  standalone: true,
})
export class SuiDialogHeaderSlot {}

@Directive({
  selector: '[suiDialogContent]',
  standalone: true,
})
export class SuiDialogContentSlot {}

@Directive({
  selector: '[suiDialogFooter]',
  standalone: true,
})
export class SuiDialogFooterSlot {}
